module.exports = __webpack_public_path__ + "img/29.5fbe85a8.png";